import jQuery from 'jquery';

jQuery.expr[':'].icontains = function(a, i, m) {
  return jQuery(a).text().toUpperCase().indexOf(m[3].toUpperCase()) >= 0;
};

jQuery.expr[':'].icontainsWords = function(a, i, m) {
  const stringWords = m[3].trim().replace(/\s{2,}/g, ' ');
  if(stringWords === '') {
    // if string is empty, does not process it. Returns true
    return true;
  }

  const words = stringWords.split(' ');
  let found  = false;
  const textToSearchIn = jQuery(a).text().toUpperCase();

  $.each(words, (index, word) => {
    // if word is empty, does not process it
    if(word == '') {
      return;
    }

    // check if the word is contained in the element text
    const wordUppercase =  word.toUpperCase();
    if(textToSearchIn.indexOf(wordUppercase) >= 0 ||
        textToSearchIn.replace(/[\.]/g, '').indexOf(wordUppercase) >= 0) {
      found = true;
      return false;
    }
  });

  return found;
};
